import React from 'react';
import { Field } from 'redux-form';
import Button from '@sizeid/commons/components/Button';

import Form from 'components/forms/Form';
import FormField from 'components/forms/FormField';
import { isSubmitDisabled } from 'utils/forms';

import Honeypot from '../Honeypot';

import ContactFormContainer from './styled/ContactFormContainer';
import { ContactFormProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ContactForm: React.FC<any> = _props => {
  const props = _props as ContactFormProps;
  return (
    <Form id={props.id} onSubmit={props.handleSubmit}>
      <Honeypot />
      <ContactFormContainer>
        <Field
          name="name"
          placeholder={props.t('contactForm.name')}
          component={FormField}
          noIcon
        />
        <Field
          name="email"
          type="email"
          placeholder={props.t('contactForm.email')}
          component={FormField}
          noIcon
        />
        <Field
          name="message"
          type="textarea"
          placeholder={props.t('contactForm.message')}
          component={FormField}
          noIcon
        />
      </ContactFormContainer>
      <Button
        type="submit"
        disabled={isSubmitDisabled(props)}
        submitting={props.submitting}
        large
        spacey
      >
        {props.t('contactForm.submit')}
      </Button>
    </Form>
  );
};

export default ContactForm;
